import React, { createContext } from 'react'
import { Theme } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'
import { themeStyles } from 'themes'

const useStyles = makeStyles<Theme>(theme => ({
    tableCardContent: {
        padding: '10px 15px 0px 15px',
    },
}))

interface IContextProps {
    classes: any
}
export const Context = createContext({} as IContextProps)

interface IProps {
    classes: any
}

const PayslipsTableFrame: React.FC<IProps> = ({ classes, children }) => {
    const localStyles = useStyles()

    return (
        <div className={classes.tableCard}>
            <div className={localStyles.tableCardContent}>
                <Context.Provider value={{ classes }}>{children}</Context.Provider>
            </div>
        </div>
    )
}
export default withStyles(themeStyles.useTableStyles)(PayslipsTableFrame)
